// Pure date/time helpers for the booking flow — PRESENTATION ONLY.
// Emits the same local "YYYY-MM-DD" / "HH:mm" values the old native inputs
// produced; the server remains the sole authority on availability and pricing.
export const SLOT_STEP_MIN = 15;

export function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function sameDay(a, b) {
  return a.toDateString() === b.toDateString();
}

// Local YYYY-MM-DD — matches <input type="date"> semantics (never toISOString,
// which would shift the day near midnight).
export function toDateStr(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function toHHMM(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function fmtTime(d) {
  return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function fmtDayLabel(d) {
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function fmtDayShort(d) {
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

export function fmtDayFull(d) {
  return d.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });
}

export function fmtSelection(d) {
  return `${fmtDayLabel(d)} · ${fmtTime(d)}`;
}

// Derived display value only — never used for pricing (server quote is authoritative).
export function durationLabel(start, end) {
  const mins = Math.max(0, Math.round((end.getTime() - start.getTime()) / 60000));
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m} min`;
  if (m === 0) return h === 1 ? "1 hour" : `${h} hours`;
  return `${h} h ${m} min`;
}

// All selectable times in 15-minute wall-clock steps (96 options) — rendered
// inside a scroll list, never as a grid. Built on a fixed date for labels only.
export const TIME_OPTIONS = (() => {
  const out = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += SLOT_STEP_MIN) {
      const d = new Date(2026, 0, 1, h, m, 0, 0);
      out.push({ hhmm: toHHMM(d), label: fmtTime(d) });
    }
  }
  return out;
})();
